module.exports = __webpack_public_path__ + "img/money@2x.5d2bbc47.png";